import React from 'react';
import { Navigate } from 'react-router';
import { AuthPage } from './AuthPage';
import { AuthEmailConfirmPage } from './AuthEmailConfirmPage';

export { AuthPage, AuthEmailConfirmPage };

/** @deprecated use /auth */
export const LoginPage: React.FC = () => <Navigate to="/auth" replace />;
/** @deprecated use /auth */
export const RegisterPage: React.FC = () => <Navigate to="/auth" replace />;
/** @deprecated passwords removed */
export const ForgotPasswordPage: React.FC = () => <Navigate to="/auth" replace />;
/** @deprecated passwords removed */
export const ResetPasswordPage: React.FC = () => <Navigate to="/auth" replace />;
/** @deprecated use /auth */
export const VerifyEmailPage: React.FC = () => <Navigate to="/auth" replace />;
